import React from 'react';
import { CompositeView, GridView, SimpleView } from '@digital/ui';
import Parametros from './Parametros';

const BidCycle = () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <Parametros />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default BidCycle;
